import connection from "../../utils/connection";

const  getLoginPublico = async (captcha ) => {
  let response = {};
  try {
    const responseGet = await connection({
      method: 'POST',
      url: '/login/loginPublico',
      body: captcha
    });
    response = responseGet;
  } catch (error) {
    console.error('catch service', error);
    response = error.response;
  }

  return response;
}


export default getLoginPublico;